import React from 'react';

import BaseSvg from '../../BaseSvg';
import { InjectedSvgProps } from '../../hocs';

export default class CheckSvg extends React.PureComponent<InjectedSvgProps> {
    render() {
        const { fillColor, className } = this.props;

        let classNames: Array<string> = ['ddbc-check-svg'];

        if (className) {
            classNames.push(className);
        }

        return (
            <BaseSvg className={classNames.join(' ')} viewBox="0 0 1792 1792">
                <path
                    fill={fillColor}
                    d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"
                />
            </BaseSvg>
        );
    }
}
